<template>
  <div class="content">
    <WebHeader menu='1'></WebHeader>
    <div class="vedio-back">
     <!-- <video-player class="video-player-box index-vedio"
                    ref="videoPlayer"  :options="playerOptions"   :playsinline="true">
      </video-player>-->

      <video-player class="video-player-box index-vedio" @pause="playerPause"
                    ref="videoPlayer"  :options="playerOptions" :playsinline="true">
      </video-player>


    </div>
    <div class="web-page">

      <!--      公司简介-->
      <div class="block-title block-title-intro">
        <div></div>
        <div>公司简介</div>
        <div></div>
      </div>
      <div class="axis">
        <div @click="toLeft()">
          <img src="static/img/left.png" alt="" class="slide">
        </div>
        <div class="axis-viewport" id="axisViewport">
          <div class="axis-slide-area" :style="axisParam.offsetStyle">
            <div class="axis-single" :style="'width:'+axisParam.singleWidth+'px;'"
                 v-for="(item , index) in axisParam.data">
              <div @click="showInfo(index)">
                <div class="step" :class="index==axisParam.index?'step-selected':'step-default'" ></div>
                <div>{{item.title}}</div>
                <div class="triangle" :class="index==axisParam.index?'triangle-selected':'triangle-default'"></div>
              </div>
            </div>
          </div>
        </div>
        <div @click="toRight()">
          <img src="static/img/right.png" alt="" class="slide">
        </div>
      </div>
      <div class="axis-info">
        <div class="contentCenter">
          <div class="borderTittle">
            <!--:style="{visibility:axisParam.index===9 ? 'visible' : 'hidden'}"-->
            <div class="topTittle" >{{axisParam.data[axisParam.index].minTitle}}</div>
          </div>
          <div class="mainText">{{axisParam.data[axisParam.index].center}}</div>
          <div class="more-button">
            <el-button >
                <div class="buttonUnderline" @click="knowAboutBusiness()">了解更多</div>
            </el-button>
          </div>
        </div>
      </div>
      <!--  中间图片    -->
      <div class="images">
        <div class="imagesTop">
          <div class="grayBack" @click="socialResponsibility()">
            <div class="MantleTop"></div>
            <div class="purpleMain">
              <img src="static/img/homePortal/logo2.png">
              <div class="bigTxt">企业社会责任</div>
              <div class="smallTxt">Corporate Social Responsibility</div>
            </div>
          </div>
          <div class="purpleBack">

            <div class="purpleTxtTop">
              <div class="purpleTxtTop1">企业战略 :</div>
              <div class="purpleTxtTop2">Enterprise Strategy</div>
            </div>

       <!--  US202402025  zhangwenxing 企业战略部分文本更新  精准创新 -> 全面国产 , 加速增长 -> 无界创新 , 业务优化-> 合作共赢 -->
            <div class="purpleTxtCenter">
              <div class="purpleTxtCenterOne" >
                <img class="img1" src="static/img/homePortal/purpleIcon1.png">
                <div class="txt11 txt1">全面国产</div>
                <div class="txt12 txt2">Localization</div>
              </div>
              <div class="purpleTxtCenterOne">
                <img class="img2" src="static/img/homePortal/purpleIcon2.png">
                <div class="txt21 txt1">无界创新</div>
                <div class="txt22 txt2">Innovation</div>
              </div>
              <div class="purpleTxtCenterOne">
                <img class="img3"src="static/img/homePortal/purpleIcon3.png">
                <div class="txt31 txt1">合作共赢</div>
                <div class="txt32 txt2">Partnership</div>
              </div>
            </div>

            <div class="purpleTxt">
             <!-- <div class="purpleTxtBottom">-->
                <div class="purpleTxtBottom1">共创无界的医疗关爱</div>
                <div class="purpleTxtBottom2">Create a world where healthcare has no limits</div>
             <!-- </div>-->
            </div>
          </div>
        </div>
       <!--US202402025 zhangwenxing start 原EVP部分上移至企业社会责任和城市之间 & 修改文本描述-->
        <div class="imagesTop" >
          <el-row style="width: 1280px" :gutter="60" >
            <el-col v-for="(o, index) in evpData" :key="index" :span="8">
              <el-card class="evpCard"  >
                <div style="padding: 0 111px 0 0;margin-bottom: 30px ">
                  <p  class="evpCardTitle">{{ o.title }}</p>
                </div>
                <div style="padding: 0 111px 0 0" >
                  <p class="evpCardText">{{ o.textRow1 }}</p>
                </div>
                <div style="padding: 0 111px 0 0" >
                  <p class="evpCardText">{{ o.textRow2 }}</p>
                </div>
              </el-card>
            </el-col>
          </el-row>

        </div>
        <!--US202402025 zhangwenxing end 原EVP部分上移至企业社会责任和城市之间 & 修改文本描述-->
        <!--城市新布局-->
        <div class="iamgesBottom">
          <div class="img1Top">
            <div class="img1 img11" @click="evaluation(0)">
              <div class="imgBox">
                <div class="underline1">北京</div>
              </div>
              <div class="iamgesBos1"></div>
              <div class="Mantle1"></div>
            </div>
            <div class="img1 img12" @click="evaluation(1)">
              <div class="imgBox">
                <div class="underline1">上海</div>
              </div>
              <div class="Mantle1"></div>
            </div>
          </div>
          <div class="img1Bottom">
            <div class="img1 img13" @click="evaluation(2)">
              <div class="imgBox">
                <div class="underline1">广州</div>
              </div>
              <div class="Mantle1"></div>
            </div>
            <div class="img1 img14" @click="evaluation(3)">
              <div class="imgBox">
                <div class="underline1">无锡</div>
              </div>
              <div class="iamgesBos2"></div>
              <div class="Mantle1"></div>
            </div>
          </div>
          <div class="more-button"  @click="TechnoParkApply()">
            <el-button>
              <div class="buttonUnderline">线上游园</div>
            </el-button>
          </div>
        </div>
      </div>
      <!--      公司业务-->
      <div class="corporateBusiness">
        <div class="block-title titleSpace">
          <div></div>
          <div>公司业务</div>
          <div></div>
        </div>
        <div class="corporateBusinessDetail">

            <div class="businessImg" @click="business('yingxiang')" >
              <div class="businessImg1">
                <div class="Mantle2" ></div>
              </div>

              <div class="txtIcon txtIcon1">
                <span class="underline2">影像</span>

                <img src="static/img/homePortal/jiantou.png">
              </div>
            </div>
            <div class="businessImg" @click="business('chaosheng')">
              <div class="businessImg2">
                <div class="Mantle2" ></div>
              </div>
              <div class="txtIcon txtIcon2">
                <span class="underline2">超声 </span>
                <img src="static/img/homePortal/jiantou.png">

              </div>
            </div>
            <div class="businessImg" @click="business('shengming')">
              <div class="businessImg3">
                <div class="Mantle21" ></div>
              </div>
              <div class="txtIcon txtIcon3">
                <span  class="underline2">生命关爱 </span>
                <img src="static/img/homePortal/jiantou.png">
              </div>
            </div>
            <div class="businessImg" @click="business('duibi')">
              <div class="businessImg4">
                <div class="Mantle21" ></div>
              </div>
              <div class="txtIcon txtIcon4">
                <span class="underline2">诊断药物</span>
                <img src="static/img/homePortal/jiantou.png">
              </div>
            </div>
        </div>
      </div>
      <div class="block-title schoolNa">
        <div></div>
        <div>加入我们</div>
        <div></div>
      </div>

      <div class="SchoolImg">

            <div class="SchoolImg1"@click="schoolEnrollmen()">
              <div class="Mantle3" ></div>
              <div class="boxTxt1 boxTxtGre">
               <p>校园招聘</p>
              </div>
            </div>

            <div class="SchoolImg2"@click="socialRecruitment()">
              <div class="Mantle3" ></div>
              <div class="boxTxt1 boxTxtBlu">
                <p>社会招聘</p>
              </div>
            </div>

      </div>

      <!--        员工故事-->
      <div class="block-title employeeStoryName">
        <div></div>
        <div>员工故事</div>
        <div></div>
      </div>
      <div class="employeeStory">
        <!--        瀑布流-->
        <div class="employeeImgs">
          <div class="item"></div>
          <div class="item"><img @click="storyParam.index=0"
                                 :src="storyParam.employeeList[0].img1"/></div>
          <div class="item"></div>
          <div class="item item1"></div>
          <div class="item"><img @click="storyParam.index=1"
                                 :src="storyParam.employeeList[1].img1"/></div>
          <div class="item"><img @click="storyParam.index=2"
                                 :src="storyParam.employeeList[2].img1"/></div>
          <div class="item"><img @click="storyParam.index=3"
                                 :src="storyParam.employeeList[3].img1"/></div>
          <div class="item"><img @click="storyParam.index=4"
                                 :src="storyParam.employeeList[4].img1"/></div>
          <div class="item"><img @click="storyParam.index=5"
                                 :src="storyParam.employeeList[5].img1"/></div>
          <div class="item item2"></div>
          <div class="item"><img @click="storyParam.index=6"
                                 :src="storyParam.employeeList[6].img1"/></div>
          <div class="item"><img @click="storyParam.index=7"
                                 :src="storyParam.employeeList[7].img1"/></div>
        </div>
        <div class="employeeDetail">
          <div class="employeeImg" >
            <img :src="storyParam.employeeList[storyParam.index].img2">
          </div>
          <div class="employeeName" @click="employeeIntro(storyParam.index)">
            {{storyParam.employeeList[storyParam.index].name}}
          </div>
         <!-- <div class="employeeUniversity">
            {{storyParam.employeeList[storyParam.index].university}}
          </div>-->
          <div class="employeeIntroduce">
            <p>{{storyParam.employeeList[storyParam.index].introduce}}</p>
          </div>
        </div>

      </div>
      <!--  US202402025 zhangwenxing start     结尾图片 更换位置至 企业社会责任和城市之间-->
<!--      <div class="evp-img">
        <div>
          <div class="mask"></div>
          <div class="evp-text">
            <p class="title1">Care for life</p>
            <p class="detal1">We care about people, quality and the way our energy helps create a healthier world.</p>
          </div>
        </div>
        <div>
          <div class="mask"></div>
          <div class="evp-text">
            <p class="title2">Think big</p>
            <p class="detal2">We embrace challenges, differences and thinking that is bigger than us.</p>
          </div>
        </div>
        <div>
          <div class="mask"></div>
          <div class="evp-text">
            <p class="title3">Unlock ambition</p>
            <p class="detal3">We unlock opportunities for us, our customers, and their patients, turning big ideas into world-changing reality.</p>
          </div>
        </div>
      </div>-->
      <!--  US202402025 zhangwenxing end     结尾图片 更换位置至 企业社会责任和城市之间-->

      <div class="banner" v-if="showPic" @click.stop="showPic=!showPic">
        <el-carousel  class="banner-carousel" arrow="always" type="card" >
          <el-carousel-item  class="banner-carousel-item" v-for="(img,imgIndex) in cityImgs.imgList[cityImgs.index]" :key="imgIndex">
            <img :src="img" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <top-button></top-button>
    <WebFooter style="margin-top: 200px"></WebFooter>
   <!-- <WebLoading></WebLoading>-->
  </div>
</template>
<script>
 /* window.onload = function () {
    document.getElementById("pageLoading").remove();
  }*/
  import TopButton from "../../components/web/topButton";
 export default {
    name: "Home",
   components: {TopButton},
   data() {
      return {
        //屏幕尺寸
        screenWidth: null,
        /**
         * 时间轴参数
         */
        axisParam: {
          offset: 0,//偏移量
          singleWidth: 220, //单节点宽度
          offsetStyle: '', //偏移样式
          index: 8, //当前时间轴节点下标
          data: [{
            title: '1897年',
            minTitle: '1897年',
            center: '苏州博习医院引入了中国历史上第一台 X线设备——GE医疗的X线机。'

          },  {
            title: '1986年',
            minTitle: '1986年',
            center: 'GE医疗在北京开设第一间办事处。'
          },{
            title: '1991年',
            minTitle: '1991年',
            center: 'GE医疗在华第一家合资企业 GE航卫医疗系统有限公司注册成立，后成为GE医疗全球主要的CT生产基地。'
          }, {
            title: '1995年',
            minTitle: '1995年',
            center: 'GE医疗华伦工厂在京成立。“华伦”名由一些有志青年员工，寓意要做“中华自己的伦琴”（伦琴射线-X射线）。现为GE医疗全球主要的X光机和OEC设备生产基地。'
          }, {
            title: '1996年',
            minTitle: '1996年',
            center: 'GE医疗与中国船舶总公司（前身为中华人民共和国第六机械工业部）合资成立无锡基地。现无锡工厂作为GE医疗全球最大的超声设备生产基地，供货全球。'
          }, {
              title: '2003年',
              minTitle: '2003年',
              center: 'GE医疗建设北京影像制造基地。航卫和华伦工厂在此合并生产CT、X光机和OEC等放射影像设备，供货全球。'
            },{
            title: '2004年',
            minTitle: '2004年',
            center: 'GE医疗在北京影像制造基地建成EMC电磁兼容实验室。'

          },{
            title: '2014年',
            minTitle: '2014年',
            center: 'GE医疗天津磁共振制造基地建成投产，这是GE医疗在美国本土以外设立的唯一一家具备生产核磁共振所用磁体和磁共振系统的工厂。现在，全球每2台磁共振即有1台产自天津工厂。'

          },

            /*US202402025 start zhangwenxing 最后一个时间点由2021修改为2024 , 同时修改 标题和内容 -->*/
            {
            title: '2024年',
            minTitle: 'GE医疗上市一周年',
            center: '在成为一家独立的上市公司后，GE医疗推出了全新雇主价值主张（Colleague Value Proposition, CVP）——共创医疗未来（Create the future of healthcare）。将原来的EVP升级为CVP，不仅仅是E-Employer到C-Colleague的变化，更表达了独立后的GE医疗更加强调企业家和主人翁精神，每一位同事都是公司发展的重要力量，公司也尽力为员工提供支持和发展空间。'
            }
            /*US202402025 end zhangwenxing 最后一个时间点由2021修改为2024 , 同时修改 标题和内容 -->*/
          ]
        },
        /*evp标题及内 US202402025 zhagnwenxing start */
        evpData:[
          {  title:"人文关爱", textRow1:"Make care", textRow2:"more human",},
          {  title:"激发创想", textRow1:"Ignite", textRow2:"bold ideas",},
          {  title:"聚力成长", textRow1:"Together", textRow2:"we thrive",}
        ],
        /*evp标题及内 US202402025 zhagnwenxing end */

        /**
         * 视频组件参数
         */
        playerOptions: {
          autoplay: true,  // 是否等浏览器准备好后自动播放
          muted: true, // 是否静音
          loop: true,// 结束后是否重新开始
          language: 'en', // 语言
          playbackRates: [],// 播放速度可选列表
          sources: [ // 播放视频源
            {type: 'video/mp4', src: require('../../../static/video/bannerVideo720.mp4')}
          ],
          // 视频比例
          // aspectRatio: '4:3',
          //  为 true 时, 播放器具有流畅的大小
          fluid: true,
          // 封面
          // poster: '/static/images/author.jpg'
          controlBar: {
            timeDivider: false,//当前时间和持续时间的分隔符
            durationDisplay: false, //显示持续时间
            remainingTimeDisplay: false, //是否显示剩余时间功能
            fullscreenToggle: false,//全屏按钮
            playToggle: false, //播放暂停按钮
            volumeMenuButton: false,  //音量控制
            currentTimeDisplay: false, //当前播放时间
            progressControl: false, //点播流时，播放进度条，seek控制
            liveDisplay: false, //直播流时，显示LIVE
            playbackRateMenuButton: false//播放速率，当前只有html5模式下才支持设置播放速率
          }
        },
        storyParam: {
          index: 0,
          employeeList: [{
            img1: require('../../../static/img/homePortal/zhenzhong1.png'),
            img2:require('../../../static/img/homePortal/zhenzhong1.png'),
            name: 'Zhenzhong',
            university:'毕业于天津大学',
            introduce: '毕业于天津大学，2016年加入GE医疗，生产运营管理培训生项目毕业，现任GE医疗天津工厂生产运营经理，主要负责天津工厂MR产品的生产运营。'

          },
            {
              img1: require('../../../static/img/homePortal/xiaojun2.png'),
              img2:require('../../../static/img/homePortal/xiaojun2.png'),
              name: 'Allen',
              university:'毕业于天津大学',
              introduce:'毕业于天津大学，2020年加入GE医疗，担任CT现场服务工程师，主要负责CT的安装、维修、保养和升级工作。'

            },
            {
              img1: require('../../../static/img/homePortal/xinyuan3.png'),
              img2: require('../../../static/img/homePortal/xinyuan3.png'),
              name: 'Steve',
              university:'毕业于麻省大学阿默斯特分校',
              introduce: '毕业于麻省大学阿默斯特分校，2022年加入GE医疗，EEDP成员，在CT软件组轮岗。'

            },
            {
              img1: require('../../../static/img/homePortal/jiahui4.png'),
              img2:require('../../../static/img/homePortal/jiahui4.png'),
              name: 'Sophia',
              university:'毕业于美国伊利诺伊大学香槟分校',
              introduce: '毕业于美国伊利诺伊大学香槟分校，2021年加入GE医疗，EEDP成员，现主要负责磁共振图像重建工作。'

            },
            {
              img1: require('../../../static/img/homePortal/xiaotian5.png'),
              img2:require('../../../static/img/homePortal/xiaotian5.png'),
              name: 'Shirly',
              university:'毕业于慕尼黑工业大学的机器人、智能与感知专业',
              introduce: '毕业于慕尼黑工业大学的机器人、智能与感知专业，于2021年加入GE医疗。目前处于第三个轮岗，主要担任网络安全分析师的工作。'

            },
            {
              img1: require('../../../static/img/homePortal/junyi6.png'),
              img2:require('../../../static/img/homePortal/junyi6.png'),
              name: 'Myc',
              university:'',
              introduce: '2022年加入GE医疗信息技术领导力项目，现轮岗于Function BP，负责对内系统维护升级。'

            },
            {
              img1: require('../../../static/img/homePortal/vivianliu8.png'),
              img2:require('../../../static/img/homePortal/vivianliu8.png'),
              name: 'Vivian',
              university:'本科毕业于上海财经大学，MBA毕业于INSEAD',
              introduce: '本科毕业于上海财经大学，MBA毕业于INSEAD，2021年7月加入GE医疗，现在central marketing进行第二个BMLP轮岗。'

            },
            {
              img1: require('../../../static/img/homePortal/longfei8.png'),
              img2:require('../../../static/img/homePortal/longfei8.png'),
              name: 'Manfred',
              university:'毕业于帝国理工学院',
              introduce: '毕业于帝国理工学院，2021年加入GE医疗，现轮岗于MR Patient Handling, 主要负责MR 检查床的上一代改进和下一代开发工作。'

            },]
        },
        showPic:false,
        cityImgs: {
          index: 0,
          imgList: [[
           require('../../../static/img/homePortal/beijing1.jpg'),
           require('../../../static/img/homePortal/beijing2.jpg'),
           require('../../../static/img/homePortal/beijing3.jpg'),
           require('../../../static/img/homePortal/beijing4.jpg'),

          ],
          [
             require('../../../static/img/homePortal/shanghai1.jpg'),
             require('../../../static/img/homePortal/shanghai2.jpg'),
             require('../../../static/img/homePortal/shanghai3.jpg'),
             require('../../../static/img/homePortal/shanghai4.jpg'),
          ],
          [
            require('../../../static/img/homePortal/guangzhou1.jpg'),
            require('../../../static/img/homePortal/guangzhou3.jpg'),
            require('../../../static/img/homePortal/guangzhou4.jpg'),
            require('../../../static/img/homePortal/guangzhou2.jpg')

          ],
          [
            require('../../../static/img/homePortal/wuxi1.jpg'),
            require('../../../static/img/homePortal/wuxi2.jpg'),
            require('../../../static/img/homePortal/wuxi3.jpg'),
            require('../../../static/img/homePortal/wuxi4.jpg'),

          ]
        ]
        },

      }
    },
    watch: {
      screenWidth(val) {
        this.screenWidth = val;
        if(val <= 615){
          this.axisParam.singleWidth = 140;
        }else{
          this.axisParam.singleWidth = 220;
        }
        this.initOffset();
      }
    },
    mounted() {
      this.$refs.videoPlayer.player.play();
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })()
      }
      this.generateOffset();
      //US202402025 进入页面时间轴自动跳转到2024年文本展示
      this.axisTo2024();
      // console.log("version:","2024/03/15 18:00")
      console.log("V3.2.0")
    },
    methods: {
      socialResponsibility(){
        window.open("https://www.gehealthcare.com/zh-cn/about-gehc-china/company-vision#pcb-sc",'_blank')
      },
      knowAboutBusiness(){
        window.open("https://www.gehealthcare.com/zh-cn/about-gehc-china/about-ge-healthcare-systems",'_blank')
      },
      TechnoParkApply(){
        window.open("https://www.720yun.com/vr/0e824xpujci",'_blank')
      },
      evaluation(index){
        this.showPic=!this.showPic;
        this.cityImgs.index=index;
      },
      business(date){
        this.$router.push({path:'/deptIntroduction',query: {point:date}})
        document.body.scrollTop = document.documentElement.scrollTop = 0
      },
      employeeIntro(date){
        console.log(date)
        document.body.scrollTop = document.documentElement.scrollTop = 0
         this.$router.push({path:'/corporateCulture',query: {name:date}})

      },
      schoolEnrollmen(){
        this.$router.push({path:'/schoolEnrollment'})
        document.body.scrollTop = document.documentElement.scrollTop = 0
      },
      socialRecruitment(){
        this.$router.push({path:'/socialRecruitment'})
        document.body.scrollTop = document.documentElement.scrollTop = 0
      },
      toLeft() {
        if (this.axisParam.offset + this.axisParam.singleWidth > 0) {
          this.axisParam.offset = 0;
        } else {
          this.axisParam.offset += this.axisParam.singleWidth;
        }
        this.generateOffset();
      },
      generateOffset: function () {
        this.axisParam.offsetStyle = {
          marginLeft: this.axisParam.offset + 'px',
          width: (this.axisParam.singleWidth * this.axisParam.data.length) + 'px'
        }
      }, toRight() {
        let axis = document.getElementById('axisViewport');
        //最大偏移量 = 时间轴总长 - 视口宽度
        let maxOffset = (this.axisParam.singleWidth * this.axisParam.data.length) - axis.offsetWidth;
        //预算偏移量
        let budgetOffset = Math.abs(this.axisParam.offset) + this.axisParam.singleWidth;
        if (budgetOffset >= maxOffset) {
          this.axisParam.offset = -maxOffset;
        } else {
          this.axisParam.offset -= this.axisParam.singleWidth;
        }
        this.generateOffset();
      },
      initOffset() {
        let axis = document.getElementById('axisViewport');
        //最大偏移量 = 时间轴总长 - 视口宽度
        let maxOffset = (this.axisParam.singleWidth * this.axisParam.data.length) - axis.offsetWidth;
        if (Math.abs(this.axisParam.offset) >= maxOffset) {
          this.axisParam.offset = -maxOffset;
          this.generateOffset();
        }
      },
      showInfo(index) {
        this.axisParam.index = index;

      },
      playerPause(){
        this.$refs.videoPlayer.player.play();
      },
      axisTo2024(){
        /*US202402025 start zhangwenxing 进入页面后时间轴展示2024年文本*/
        for (let i = 0; i < 6; i++) {
          this.toRight()
        }
        /*US202402025 end zhangwenxing 进入页面后时间轴展示2024年文本*/
      }
    }
  }
</script>

<style>
  .video-js .vjs-big-play-button {
    left: 50%;
    margin-left: -1.5em;
    margin-top: 20%;
  }
  .el-carousel__container{
    height: 85vh;
  }
 .evp-img .el-divider{
   width: 4px;
   height: 20px;
   line-height: 40px;
   margin-bottom: 10px;
 }
  .banner .el-carousel__mask{
    background:none;
  }
  .banner .el-carousel__item{
    opacity: 0.4;
  }
  .banner .is-active{
    opacity: 1;
  }

  .vedio-back .video-js .vjs-big-play-button {
    left: 50%;
    margin-left: -1.5em;
    margin-top: 20%;
  }
  .vedio-back .vjs-big-play-button{
    display: none;
  }
</style>
<style scoped>

  .index-vedio {
    width: 100%;
    height: auto;
  }

  .axis {
    width: 1350px;
    margin: 0 auto;
    height: 140px;
    display: flex;
    justify-content: space-between;
  }

  .axis-viewport {
    width: 88%;
    height: 150px;
    overflow: hidden;
  }

  .axis-slide-area {
    height: 140px;
    transition: all 1s;
  }

  .axis-single {
    margin-top: 25px;
    width: 180px;
    height: 112px;
    float: left;
    border-top: 3px solid #6400a0;
  }

  .axis-single > div {
    width: 100%;
    height: 112px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    font-size: 26px;
  }

  .axis-single .step {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-top: -17px;
    box-shadow: #fff 0 0 0 3px;
    cursor:pointer;
  }

  .axis-single .step-default {
    background-color: #AEAEAE;
  }

  .axis-single .step-selected {
    background-color: rgb(100 0 160);
  }

  .axis .slide {
    width: 22px;
    height: 41px;
    margin: 4px 0 0 0px;
    cursor:pointer;
  }

  .triangle {
    width: 0;
    height: 0;
    border-left: 22px solid transparent;
    border-right: 22px solid transparent;

  }

  .triangle-default {
    border-bottom: 22px solid #ffffff;
  }

  .triangle-selected {
    border-bottom: 22px solid #E9E9E9;
  }



  /*  公司简介内容介绍*/
  .axis-info {
    width: 100%;
    background-color: #E9E9E9;
    overflow: hidden;
    min-height: 410px;
  }

  .contentCenter {
    margin: 0 auto;
    width: 62.6%;
    color: #5F5F5F;
    position: relative;

  }

  .topTittle {
    padding-left: 10px;
    height: 10%;
    border-left: solid #6400a0 10px;

    font-size: 30px;
    font-weight: 600;
    color: #333333;
    margin-top: 58px;
    margin-bottom: 27px;

  }

  .mainText {
    /*margin: 10px auto 40px auto;*/
    /*text-indent: 1em;*/
    font-size: 24px;
    line-height: 45px;
    font-weight: 400;
    color: #5F5F5F;
   /* padding-bottom: 86px;*/


  }

  /*中间图片*/
  .imagesTop{
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    -webkit-justify-content: center;
    /*flex-wrap: wrap;
    -webkit-flex-wrap: wrap;*/
    margin: 68px 50px 81px ;
  }
  .grayBack{
    width: 600px;
    height: 400px;
    background-image: url("../../../static/img/homePortal/strategeImage.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    justify-content: center;
    -webkit-justify-content: center;
    position: relative;
    transition: background-size 1s;
    cursor:pointer;
  }
  .grayBack:hover{
    background-size:120% 120%;
  }

  .grayBack:hover .bigTxt{
    text-decoration: underline;
    text-underline-offset:10px;
    text-decoration-thickness:2px;

  }

  .grayBack:hover .smallTxt{
    text-decoration: underline;
    text-underline-offset:5px;
    text-decoration-thickness:2px;

  }
  .purpleMain{
    margin-left: 39px;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    justify-content: flex-start;
    -webkit-justify-content: flex-start;
    z-index: 1;
  }
  .purpleMain img{
    width: 276px;
    /*height: 69px;*/
    height: 67px;
  }

  .bigTxt{
    font-size: 30px;
    font-weight: 500;
    color: #FFFFFF;
    margin-top: 20px;
  }
  .smallTxt{
    font-size: 20px;
    font-weight: 500;
    color: #FFFFFF;
    margin-top: 9px;
  }
  .MantleTop{
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    background-image: linear-gradient(to right, rgba(105, 11, 162, 1), rgba(105, 11, 162, 0));


  }

  .purpleBack{
    width: 600px;
    height: 400px;
    background: #F4F4F4;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    align-content: space-between;
    -webkit-align-content: space-between;
    position: relative;

  }
  .purpleTxtTop{
    margin-top: 25px;
    margin-left: 29px;
  }
  .purpleTxtTop1{
    font-size: 30px;
    font-weight: 500;
    color: #6400a0;
  }
  .purpleTxtTop2{
    font-size: 20px;
    font-weight: 500;
    color: #6400a0;
    margin-top: 7px;
  }

.purpleTxtCenter{
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  margin: 49px 41px 50px 41px;
}
.purpleTxtCenterOne{
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  align-items: center;
  -webkit-align-items: center;
}
  .purpleTxtCenterOne .img1{
    width: 56px;
    height: 50px;

  }
  .purpleTxtCenterOne .img2{
    width: 45px;
    height: 50px;
  }
  .purpleTxtCenterOne .img3{
    width: 47px;
    height: 51px;
  }
.txt1{
  font-size: 18px;
  font-weight: 600;
  color: #6400a0;

}
  .txt2{
    font-size: 15px;
    font-weight: 500;
    color: #6400a0;
    margin-top: 10px;
  }
  .txt11{
    margin-top: 25px;
  }

  .txt21{
    margin-top: 25px;
  }

  .txt31{
    margin-top: 24px;
  }


  .purpleTxt{
    width: 100%;
    height: 22.75%;
    background-color: #6400a0;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
   justify-content: center;
    -webkit-justify-content: center;
    position: absolute;
    left:0px;
    bottom: 0px;


  }
.purpleTxtBottom1{
  font-size: 24px;
  font-weight: 500;
  color: #FFFFFF;
  margin-left: 30px;
}
.purpleTxtBottom2{
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: 4px;
  margin-left: 30px;
}

  .imagesTop2 img {
    width: 100%;
    vertical-align: bottom;
    display: block;

  }
  /*城市新布局*/
  .iamgesBottom{
    margin: 81px auto 0 ;
    max-width: 1232px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

  }
  .img1Top{
    width: 616px;
    display: flex;
    justify-content: center;
  }

  .img1Top .img1{
    cursor:pointer
  }
  .img1Bottom{
    width: 616px;

    display: flex;
    justify-content: center;

  }
  .img1Bottom .img1{
    cursor:pointer
  }
  .img1{
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    width: 277px;
    height: 432px;
    margin: 0px 15.5px 0px 15.5px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    transition: background-size 1s;
    position: relative;
    border-radius: 8px 8px 8px 8px;
    overflow: hidden;
    display: -webkit-flex; /* Safari */
    -webkit-justify-content: flex-end;

  }

  .Mantle1{
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    border: rgba(0,0,0,0.2);
    /*background-image: linear-gradient(to right, rgba(0,0,0,0.5), rgba(0,0,0,0.1));*/
    background-color: rgba(0,0,0,0.3);
  }
  .img1:hover{
    background-size:120% 120%;
  }

  .img1:hover .underline1{
     border-bottom: 2px solid white;
    padding: 5px 0 3px;

  }
 /*.underline{*/
 /*  border-bottom: 1px solid white;*/
 /*  padding-bottom: 3px;*/
 /* }*/
  .img11{
    background-image: url("../../../static/img/homePortal/huabei.jpg");
    position: relative;
  }
  .img12{
    background-image: url("../../../static/img/homePortal/huadong.jpg");
  }
  .img13{
    background-image: url("../../../static/img/homePortal/huanan.jpg");
  }
  .img14{
    background-image: url("../../../static/img/homePortal/huazhong.jpg");
    position: relative;
  }
  .imgBox{
    width: 100%;
    height: 86px;
    background-color: rgba(0,0,0,0.5);
    border-radius: 0px 0px 8px 8px;
    font-size: 32px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 52px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    z-index: 1;


  }
  .img11{
    position: relative;

  }
  .iamgesBos1 {
    width: 40%;
    height: 61%;
    background-color: #640acd;
    position: absolute;
    /*top: 40%;*/
    left: -17px;
    bottom: -18px;
    z-index: -1;
  }
 .img14{
  position: relative;

 }
  .iamgesBos2 {
    width: 40%;
    height: 61%;
    background-color: #640acd;
    position: absolute;
    top: -18px;
    right: -17px;
    z-index: -1;
  }
  .more-button{
    width: 100%;
    display: flex;
    display: -webkit-flex;
   /* justify-content: right;*/
    justify-content: flex-end ;
    -webkit-justify-content: flex-end;
    margin: 20px 0 44px 0;
  }

  .more-button button{
    padding: 8px 28px;
    background-color: #6400a0;
    /*#6400a0*/
  /*  background-color: rgb(100 0 160);*/
    border-radius: 26px;
    color: #FFFFFF;
    font-size: 22px;
    border: none;
  }


  /*  公司业务*/
  .corporateBusiness {
    width: 100%;
    background-color: #E9E9E9;
    overflow: hidden;
  }

  .titleSpace{
    margin: 66px 0 68px;
  }

  .corporateBusinessDetail{

    margin: 0 auto 8px;
    max-width: 1230px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;


  }
  .businessImg{

    border-radius: 8px;
    box-shadow: 3px 3px 16px 7PX #dbdbdb;
    background-color: #f8f8f8;
    width: 585px;
    height: 414px;
    margin: 0px 15px 49px 15px;
    cursor:pointer

  }
  .businessImg > div:first-child{
    width: 585px;
    height: 304px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    transition: background-size 1s;
    border-radius: 8px 8px 0 0;
    position: relative;

    border-radius: 8px 8px 0px 0px;
    overflow: hidden;

  }

  .Mantle2{
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    /*background-image: linear-gradient(to right, rgba(0,0,0,0.5), rgba(0,0,0,0.1));*/
    background-color: rgba(0,0,0,0.35);
  }
  .Mantle21{
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    /*background-image: linear-gradient(to right, rgba(0,0,0,0.5), rgba(0,0,0,0.1));*/
    background-color: rgba(0,0,0,0.4);
  }


  .businessImg:hover > div:first-child{
    background-size: 120% 120%;
  }

  .businessImg1 {
    background-image: url("../../../static/img/homePortal/business1.jpg");
  }
  .businessImg2 {
    background-image: url("../../../static/img/homePortal/business2.jpg");
  }
  .businessImg3 {
    background-image: url("../../../static/img/homePortal/business3.jpg");
  }
  .businessImg4 {
    background-image: url("../../../static/img/homePortal/business4.jpg");
  }
   .businessImg:hover .underline2{
    border-bottom: 3px solid #6400a0;
    padding: 5px 0 3px;
  }
 /*  .txtIcon:hover .underline2{
     border-bottom: 3px solid #f8f8f8;
     padding: 5px 0 3px;
   !* border: none;*!
   }*/
   .underline2{
     border-bottom: 3px solid #f8f8f8;
     padding: 5px 0 3px;
   }






  .txtIcon {
    width: 555px;
    height: 110px;
    display: flex;
    align-items: center;
    background-color: #f8f8f8;

    padding-left: 30px;
    font-size: 30px;
    font-weight: 600;
    color: #6400a0;
    border-radius: 0 0 8px 8px;
  }


  .txtIcon img{
    width: 14px;
    height: 25px;
    margin-left: 20px;
  }


  .imaBack1 img {
    width: 100%;
    display: block;
  }


/*校园招聘*/
  .schoolNa{
    margin: 73px 0 25px;
  }

  .SchoolImg {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

  }

  .SchoolImg1 {
    width: 585px;
    height: 350px;
    margin: 67px 15px 0px;
    background-image: url("../../../static/img/homePortal/campusRecruitment.jpg");
    position: relative;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    transition: background-size 1s;
    position: relative;
    border-radius: 8px 8px 8px 8px;
    overflow: hidden;
    cursor:pointer


  }
  .SchoolImg1:hover ,.SchoolImg2:hover{
    background-size: 120% 120%;
  }
  .SchoolImg2 {
    width: 585px;
    height: 350px;
    margin: 67px 15px 0px;
    background-image: url("../../../static/img/homePortal/socialRecruitment.jpg");
    position: relative;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    background-position: center;
    transition: background-size 1s;
    position: relative;
    border-radius: 8px 8px 8px 8px;
    overflow: hidden;
    cursor:pointer
  }
  .Mantle3{
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    /*background-image: linear-gradient(to right, rgba(0,0,0,0.5), rgba(0,0,0,0.1));*/
    background-color: rgba(0,0,0,0.5);
  }

  .boxTxt1{
    width: 100%;
    height: 31%;
    bottom: 0px;
    left: 0px;
    position: absolute;
    display: flex;
    align-items: center;
    font-size: 36px;
    font-weight: 600;
    color: #FFFFFF;
  }
  .boxTxt1 p{
    margin-left: 31px;
  }
  .boxTxtGre{
   background-color: rgba(56,195,250,0.8);
    box-shadow: 0px 7px 16px 0px rgba(14,14,14,0.08)
  }
  .boxTxtBlu{
    background-color: rgba(82,223,180,0.8)
  }
  .SchoolImg1:hover p{
    border-bottom: 3px solid white;
    padding: 5px 0 3px;
  }
  .SchoolImg2:hover p{
    border-bottom: 3px solid white;
    padding: 5px 0 3px;
  }


  /*员工故事*/

  .employeeStoryName{
    margin: 5.83vw 0 9.11vw;
  }
  /*瀑布流*/
  .employeeImgs{
    column-count: 4;
    column-gap: 0.99vw;
    width: 32.5vw;
    margin-top: 51px;

  }
  .item{
    height: 7.55vw;
    padding: 0.42vw 0;
  }
  .item1{
    height: 4.7vw;
  }
  .item2{
    height: 1.88vw;
  }
  .item img{
    width: 7.55vw;
    height: 7.55vw;
    border-radius: 5px;
    transition:transform 1s ;
    cursor:pointer
  }
  .item img:hover{
    transform: scale(1.3);
  }
  @-webkit-keyframes employeeHeader{
    10% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
  .employeeStory{
    width: 62.5vw;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin: 0 auto;
  }

  .employeeDetail{
    /*margin-left: 105px;*/
    width: 17.76vw;
    display: flex;
    flex-direction: column;
    align-items: center;

    /*float: left;*/

  }
  .employeeImg img{
    border-radius: 50%;
    width: 12.24vw;
    height: 12.24vw;

  }
  .employeeName{
    text-align: center;
    margin-top: 36px;
    margin-bottom: 28px;
    cursor:pointer;
    color: #6400a0;
    font-size: 1.21vw;
    font-weight: 400;

  }
  /*.employeeName{
    border-bottom: 2px solid #6400a0;
  }*/
  .employeeName{
    border-bottom: 2px solid #6400a0;
    color: #6400a0;
  }
  .employeeUniversity{
    text-align: center;
    font-size: 0.94vw;
    font-weight: 400;
    color: #666666;
  }
  .employeeIntroduce p{
    /* letter-spacing: 1px;*/
    font-size: 0.94vw;
    font-weight: 400;
    color: #666666;
    line-height: 1.8vw;
  }

  /*结尾图片*/

  .endImg img{
    width: 380px;
    height: 255px;
    margin:15px;
  }

  .banner{
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.9);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .banner-carousel{
    width: 80%;
  }
  .banner-carousel .banner-carousel-item{
    background: rgba(0,0,0,0);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .banner-carousel .banner-carousel-item img{
    width: auto;
    height: auto;
    max-width: 75vw;
    max-height: 60vh;
  }
  .block-title-intro{
    margin: 50px 0 50px 0;
  }
  .evp-img{
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    margin: 132px auto 215px auto;
    justify-content: center;
    -webkit-justify-content: center;
    /*padding: 0 50px;*/
  }
  .evp-img > div{
    margin: 15px;
    width: 380px;
    height: 406px;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    display: -webkit-flex;
    align-items: flex-end;
    -webkit-align-items: flex-end;
    border-radius: 8px;
    transition: background-size 1s;
    position: relative;

  }
  .evp-img .evp-text{
    height: 184px;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    justify-content: flex-end;
    -webkit-justify-content: flex-end;
    padding-bottom: 31px;
    padding-left: 30px;
    border-radius: 0 0 8px 8px;
    z-index: 2;
  }

  .evp-img > div:nth-child(1){
    background-image: url("../../../static/img/homePortal/care_for_life.jpg");
  }
  .evp-img > div:nth-child(2){
    background-image: url("../../../static/img/homePortal/think_big.jpg");
  }
  .evp-img > div:nth-child(3){
    background-image: url("../../../static/img/homePortal/unlock_ambition.jpg");
  }
  .evp-img > div:hover{
    background-size: 120% 120%;

  }
  .evp-text > p:nth-child(1){
    font-size: 36px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 36px;
  }
  .evp-text > p:nth-child(2){
    font-size: 12px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 20px;
    margin-top: 29px;
  }
  .title1{
    width: 29%;
  }
  .detal1{
  width: 44.5%;
  }
  .title2{
    width: 23%;
  }
  .detal2{
    width: 39.7%;
  }
  .title3{
    width: 35%;
  }
  .detal3{
    width: 57%;
  }
  .evp-img  .mask{
    width: 380px;
    height: 406px;
    position: absolute;
    z-index: 1;
    border-radius: 8px;
    padding: 0;
    margin: 0;
    background-image: linear-gradient(to right, rgba(105, 11, 162, 1), rgba(105, 11, 162, 0));
  }

  @media screen and (min-width: 869px) and (max-width: 1200px) {
    .iamgesBottom .img1 {
      margin-bottom: 10px;
    }

    .iamgesBos1 {
      display: none;
    }

    .iamgesBos2 {
      display: none;
    }
  }
  @media screen and (min-width: 869px) and (max-width: 1520px) {
    .axis {
      width: 90vw;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }
  }

  @media screen and (max-width: 1252px) {
    .iamgesBos1 {
      display: none;
    }

    .iamgesBos2 {
      display: none;
    }
    .img1Bottom{
      margin-top: 30px;
    }


  }
  /*按钮下划线*/
  @media screen and (min-width: 868px) {
  /*    .more-button button:hover{
      background-color: #d2a1fa;
      color: #222222;
    }*/
    .el-button:hover .buttonUnderline {
      border-bottom: 2px solid white;
      padding: 5px 0 3px;

    }

   .buttonUnderline{
    border-bottom: 2px solid #6400a0;
    padding: 5px 0 3px;
   }

  }


  @media screen and (max-width: 868px) {
      /*小分辨率*/
    /*按钮*/
    .more-button{
      margin: 20px 0 44px 0;
    }
    .more-button button{
      padding: 8px 14px;
      font-size: 1.6vw;
    }
    .axis {
      width: 90%;
      padding: 0 2%;

    }
    .axis-info {
      min-height: 300px;
    }
    .axis .slide {
      width: 11px;
      height: 20px;
      margin: 15px 0 0 0px;
    }
    .axis-single .step {
      width: 18px;
      height: 18px;
      margin-top: -11px;
    }
    .triangle-selected {
      border-bottom: 17px solid #E9E9E9;
    }
    .triangle {
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
    }
    .axis-single > div {
      font-size: 16px;
    }
    .employeeStory{
      width: 80vw;
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
    }
    .employeeStoryName{
      margin: 51px 0 79px;
    }


    .employeeImgs{
      column-gap: 2.37vw;
      width: 78vw;
    }
    .item{
      height: 18vw;
      padding: 1.01vw 0;
    }

    .item img{
      width: 18vw;
      height: 18vw;
    }

    .employeeDetail{
      width: 78vw;

    }
    .employeeImg img{
      width: 29.37vw;
      height: 29.37vw;

    }
    .employeeName{
      font-size: 2.9vw;
    }
    .employeeUniversity{
      font-size: 2.25vw;
    }
    .employeeIntroduce p{
      font-size: 2.25vw;
      line-height: 4.32vw;
    }
    .item1{
      height: 11.28vw;
    }
    .item2{
      height: 4.51vw;
    }


    .contentCenter {
      width: 80%;
      color: #5F5F5F;
    }

    .topTittle {
      padding-left: 4px;
      font-size: 18px;
      margin-top: 25px;
      margin-bottom: 11px;
    }

    .mainText {
      font-size: 16px;
      line-height: 32px;
      padding-bottom: 82px;
    }

    .iamgesBottom {
      width: 90%;
      margin: 0 auto 40px auto;
      position: relative;
    }

    .iamgesBottom .img1 {
      margin-bottom: 10px;
    }

    .iamgesBos1 {
      display: none;
    }

    .iamgesBos2 {
      display: none;
    }
    /*城市*/
    .imgBox {
      font-size: 4vw;
    }
    /*学校社会招聘*/
    .schoolNa{
      margin: 3.8vw 0 1.3vw;
    }

    .SchoolImg {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .SchoolImg1 {
      width: 73.2vw;
      height: 43.75vw;
      margin-top: 33px;

    }
    .SchoolImg2 {
      width: 73.2vw;
      height: 43.75vw;
      margin-top: 33px;
    }
    .boxTxt1{

      font-size: 24px;
      height: 28%;
    }
    /*公司业务*/
    .titleSpace{
      margin: 3.43vw 0 3.54vw;
    }
    .corporateBusinessDetail {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 10vw;

    }

    .businessImg {
      width: 73.2vw;
      height: 51.8vw;
      margin-bottom: 0px;
      margin-top: 33px;
    }
    .businessImg > div:first-child{
      width: 73.2vw;
      height: 73.4%;
    }
    .txtIcon {
     /* font-size: 24px;*/
      font-size: 3.748vw;
      height: 26.6%;
      width: 69.36vw;
      padding-left: 3.84vw;
    }
    .txtIcon img{
      width: 1.75vw;
      height: 3.12vw;
      margin-left: 2.5vw;
    }
    /*结尾图片*/
    .endImg{
      margin: 6.35vw auto 11.2vw auto;
      display: flex;
      flex-direction: column;
      align-items: center;

    }
    .endImg img{
      width: 47.52vw;
      height: 31.87vw;
      margin: 15px;
    }
    /*中间图片*/
    .imagesTop{
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      -webkit-justify-content: center;
      flex-wrap: wrap;
      -webkit-flex-wrap: wrap;
      margin: 68px 0 81px ;
    }
    .grayBack{
      width: 75vw;
      height: 49.9vw;
    }

    .purpleBack{
      width: 75vw;
      height: 49.9vw;
    }


    .purpleMain{
      margin-left: 4.87vw;

    }
    .purpleMain img{
     /* width: 8.62vw;*/
      width: 34.5vw;
      height: 8.62vw;

    }

    .bigTxt{
      font-size: 3.748vw;
      margin-top: 2.498vw;
    }
    .smallTxt{
      font-size: 2.498vw;
      margin-top: 1.123vw;
    }


    .purpleTxtTop{
      margin-top: 3.125vw;
      margin-left: 3.624vw;
    }
    .purpleTxtTop1{
      font-size: 3.748vw;

    }
    .purpleTxtTop2{
      font-size: 2.498vw;
      margin-top: 0.864vw;
    }

    .purpleTxtCenter{
     /* margin: 6.125vw 5.124vw 6.25vw 5.124vw;*/
      margin: 4.125vw 5.124vw 6.25vw 5.124vw;
    }

    .purpleTxtCenterOne .img1{
      width: 6.99vw;
      height: 6.25vw;
    }
    .purpleTxtCenterOne .img2{
      width: 5.623vw;
      height: 6.25vw;
    }
    .purpleTxtCenterOne .img3{
      width: 5.873vw;
      height: 6.374vw;
    }
    .txt1{
      font-size: 2.25vw;

    }
    .txt2{
      font-size: 1.874vw;
     /* margin-top: 1.248vw;*/
      margin-top: 0.248vw;
      text-align: center;
    }
    .txt11{
      margin-top: 3.125vw;
    }

    .txt21{
      margin-top: 3.125vw;
    }

    .txt31{
      margin-top: 3vw;
    }
    .purpleTxt{
    /*  width: 100%;
      height: 22.75%;
*/
height: 11.374vw;
    }


    .purpleTxtBottom1{
      font-size: 3vw;
      margin-left: 3.75vw;
    }
    .purpleTxtBottom2{
      font-size: 1.75vw;
      margin-top: 0.499vw;
      margin-left: 3.75vw;
    }

    /*

        .purpleTxt > div{
          line-height: 2.6vw;
        }
        .purpleTxt > div > span{
          font-size: 2.6vw;
        }
        .purpleTxt > div > div{
          font-size: 3.7vw;
        }
    */

    .evp-img{
      display: flex;
      display: -webkit-flex;
      flex-wrap: wrap;
      -webkit-flex-wrap: wrap;
      margin: 132px auto 215px auto;
      justify-content: center;
      -webkit-justify-content: center;
      /*padding: 0 50px;*/
    }


    .evp-img > div{
      margin: 15px;
      width: 67.3vw;
      height: 71.89vw;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      display: flex;
      display: -webkit-flex;
      align-items: flex-end;
      -webkit-align-items: flex-end;
      border-radius: 8px;
      transition: background-size 1s;

    }
    .evp-img  .mask {
      width: 67.3vw;
      height: 71.89vw;
      position: absolute;
      z-index: 1;
      border-radius: 8px;
      padding: 0;
      margin: 0;
      background-image: linear-gradient(to right, rgba(105, 11, 162, 1), rgba(105, 11, 162, 0));
    }
    .evp-text > p:nth-child(1){
      font-size: 6.375vw;
      /*line-height: 36px;*/
      line-height: 6.375vw;
    }
    .evp-text > p:nth-child(2){
      font-size: 2.125vw;
      line-height: 3.54vw;
     /* line-height: 20px;*/
      margin-top: 5.134vw;
    }

    /*.evp-img .evp-text{
      height: 184px;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding-bottom: 31px;
      padding-left: 30px;
      border-radius: 0 0 8px 8px;
      z-index: 2;
    }


    .title1{
      width: 28%;
    }
    .detal1{
      width: 44.5%;
    }
    .title2{
      width: 23%;
    }
    .detal2{
      width: 39.7%;
    }
    .title3{
      width: 35%;
    }
    .detal3{
      width: 57%;
    }
    .evp-img  .mask{
      width: 380px;
      height: 406px;
      position: absolute;
      z-index: 1;
      border-radius: 8px;
      padding: 0;
      margin: 0;
      background-image: linear-gradient(to right, rgba(100,10,205,1), rgba(100,10,205,0));
    }*/
    /*.evp-img{
      display: flex;
      flex-wrap: wrap;
      margin: 132px auto 215px auto;
      justify-content: center;
      !*padding: 0 50px;*!
    }
    .evp-img > div{
      margin: 15px;
      width: 67.3vw;
      height: 45.16vw;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      display: flex;
      align-items: flex-end;
      border-radius: 8px;
    }
    .evp-img .evp-text{
      height: 13.81vw;
      width: 100%;
      display: flex;
      align-items: center;
      padding: 0 7px;
      font-size: 12px;
      color: #ffffff;
      font-weight: bold;
      line-height: normal;
      letter-spacing: 1px;
      background-color: rgba(0,0,0,0.6);
      border-radius: 0 0 8px 8px;
      z-index: 2;
    }
    .evp-img  p{
      width: 92%;
    }
    .evp-img  .mask{
      width: 67.3vw;
      height: 45.16vw;
      position: absolute;
      z-index: 1;
      border-radius: 8px;
      background-color: rgba(0,0,0,0.5);
      padding: 0;
      margin: 0;
    }
*/
    /*城市适配*/

    .iamgesBottom{
      margin: 81px auto 120px auto;
      display: flex;
      flex-direction: column;
      align-items: center;

    }
    .img1Top{
      width: 77vw;

    }
    .img1Bottom{
      width: 77vw;
      height: 62.62vw;

    }

    .img1{
      width: 34.62vw;
      height: 54vw;
      margin: 0px 1.94vw 0px 1.94vw;

    }
    .img1Bottom{
      margin-top: 3.72vw;
    }
    .imgBox{
      width: 100%;
      height: 10.75vw;
      font-size: 4vw;
      line-height: 6.5vw;

    }



  }

  @media screen and (min-width: 1920px) {

    .employeeImgs{
      column-gap: 15px;
      width: 622px;
      margin-top: 51px;

    }
    .item{
      height: 145px;
      padding: 9.5px 0;
    }
    .item1{
      height: 91px;
    }
    .item2{
      height: 36px;
    }
    .item img{
      width: 145px;
      height: 145px;

    }
    .employeeStory{
      width: 62.5%;
    }

    .employeeDetail{
      width: 341px;

    }
    .employeeImg img{
      width: 235px;
      height: 235px;

    }
    .employeeName{

      font-size: 24px;
    }
    .employeeUniversity{
      font-size: 18px;
    }
    .employeeIntroduce p{
      font-size: 18px;
      line-height: 36px;
    }

  }
  @media screen and (max-width: 320px) {
    .purpleTxtBottom1{

    }
  }

  .evpCard{
    background-color: #6400a0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 250px;
    /*margin: 0 46px;*/
    border-radius: 15px;
  }

  .evpCardTitle{
    letter-spacing:1px;/*文字间距*/
    margin: 0;
    font-size: 35px;
    font-weight: 700;
    color: #FFFFFF;
  }
  .evpCardText{
    letter-spacing:1px;
    font-size: 30px;
    font-weight: 600;
    color: #FFFFFF;
    margin-top: 4px;

  }


</style>



// WEBPACK FOOTER //
// src/views/web/home.vue